/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ClientGroupExtended, ClientGroupExtendedDetail } from '@DigitaleDoerfer/digitale-doerfer-api';
import { BaseError } from '../../../shared/errors/Errors';
import { Pagination } from '../../../shared/services/InMemoryTable.service';
import { TableColumnSortingDirection, TableSorting } from '../../../shared/views/Table/TableSorting';

export interface ListSearchParams {
	text: string;
	tenantId: string;
	pagination: Pagination;
	sorting: TableSorting;
}

export enum EmptyField {
	NONE = 'NONE'
}

export interface GroupState {
	list: {
		groups: ClientGroupExtended[];
		searchParams: ListSearchParams;
		loading: boolean;
		error: BaseError | null;
	};
	detail: {
		group: ClientGroupExtendedDetail | null;
		loading: boolean;
	};
	create: {
		groupHasBeenCreated: boolean;
		loading: boolean;
		error: BaseError | null;
	};
}

export const initialGroupState: GroupState = {
	list: {
		groups: [],
		searchParams: {
			text: '',
			tenantId: EmptyField.NONE,
			pagination: {
				page: 0,
				rowsPerPage: 20,
				total: 0
			},
			sorting: { columnId: 'group', direction: TableColumnSortingDirection.ASC }
		},
		loading: false,
		error: null
	},
	detail: {
		group: null,
		loading: false
	},
	create: {
		groupHasBeenCreated: false,
		loading: false,
		error: null
	}
};
